<template>
  <div class="container">
    <div style="margin-bottom: 1rem">
      <el-row>
        <content-title :nav="nav"></content-title>
      </el-row>
      <el-descriptions :title="device.device_name">
        <el-descriptions-item label="设备SN">
          {{ device.device_id }}
        </el-descriptions-item>
        <el-descriptions-item label="设备类型">
          {{ getNameByValue(deviceCode, device.device_code) }}
        </el-descriptions-item>
         <el-descriptions-item label="状态">
         <el-tag type="success" v-if="device.active_status == 1">在线</el-tag>
          <el-tag type="info" v-else>离线</el-tag>
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <el-tabs v-model="activeName" @tab-click="tabClick">
      <el-tab-pane label="概览" name="summary">
        <deviceSummary ref="summary"></deviceSummary>
      </el-tab-pane>
      <el-tab-pane label="设备节点" name="node">
        <deviceNode :device="device" ref="node"></deviceNode>
      </el-tab-pane>
      <el-tab-pane label="连接" name="conn"> 
        <deviceConn :device="device" ref="conn"></deviceConn>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
  
<script>
import { deviceCode } from "@/views/deviceManage/components/dict";
import deviceSummary from "./components/deviceSummary/deviceSummary.vue";
import deviceConn from './components/deviceConn/deviceConn.vue';
import deviceNode from './components/deviceNode/deviceNode.vue';

export default {
  components: {
    deviceSummary,
    deviceConn,
    deviceNode
  },
  data() {
    return {
      deviceCode,
      id: "",
      nav: { firstNav: "投资方", secondNav: "详情" },
      device: {},
      activeName: "summary",
    };
  },
  methods: {
    tabClick(v) {
      this.$refs[v.name].init();
    },
    getDetails() {
      let url = "/device/device/find";
      let data = {
        device_id: this.id
      }
      this.$post(url,data)
        .then((res) => {
          this.device = res.data.data;
        });
    },
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getDetails();
    this.$nextTick(() => {
      this.$refs[this.activeName].init();
    });
  },
};
</script>
  
<style></style>
  